import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Premium from '@wix/da-ds/pkg/Icons/24x24/Premium';
import EyeDisc2 from '@wix/da-ds/pkg/Icons/24x24/EyeDisc2';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import CoreStar from '@wix/da-ds/pkg/Icons/CoreStar';
var PremiumIcon = function (_a) {
    var className = _a.className, premiumFolderData = _a.premiumFolderData, _b = _a.withTooltip, withTooltip = _b === void 0 ? true : _b, tooltipClassName = _a.tooltipClassName;
    var t = useTranslation().t;
    var _c = normalizePremiumFolderData(premiumFolderData), isPremium = _c.isPremium, isPaidFolder = _c.isPaidFolder, isWatchToAccess = _c.isWatchToAccess, isPrivilegedFolder = _c.isPrivilegedFolder;
    if (!isPremium) {
        return null;
    }
    var icon = isPaidFolder ? (React.createElement(Premium, { size: IconSize.MEDIUM, className: className })) : isWatchToAccess ? (React.createElement(EyeDisc2, { size: IconSize.MEDIUM, className: className })) : isPrivilegedFolder ? (React.createElement(CoreStar, { className: className, customSize: { width: 24, height: 24 } })) : null;
    var transKey = isPaidFolder
        ? 'deviationview.paywall.thumb.premiumFolder.tooltip'
        : isWatchToAccess
            ? 'deviationview.paywall.thumb.watchersOnly.tooltip'
            : isPrivilegedFolder
                ? 'deviationview.paywall.thumb.privilegedFolder.tooltip'
                : '';
    return withTooltip ? (React.createElement(SimpleTooltip, { text: t(transKey), className: tooltipClassName, usePortal: true }, icon)) : (icon);
};
PremiumIcon.displayName = 'PremiumIcon';
export default PremiumIcon;
//# sourceMappingURL=PremiumIcon.js.map